// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__20nqh","col":"CardReaderDesc_col__37chb","label":"CardReaderDesc_label__2Y5JF"};